import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Register service worker
// TEMPORARILY DISABLED to fix API request issues
if (false && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(registration => {
        console.log('ServiceWorker registered:', registration);
        // In development, skip waiting to activate new service worker immediately
        if (import.meta.env.DEV && registration.waiting) {
          registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        }
      })
      .catch(error => {
        console.error('ServiceWorker registration failed:', error);
        // In development, this is not critical
        if (import.meta.env.DEV) {
          console.log('Service worker registration error is expected in development');
        }
      });
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
